import { STAGE_LOCATION_TYPE } from "./Constants";

const OVERFLOW_LOCATION_SUFFIX = " (Overflow)";

/**
 * Returns staging location of route.
 * Pre-requisite: transformStagingLocations should be executed on route before this method.
 *
 * @param rswsRoute - response route obj from rsws
 */
export function getRouteStagingLocation(rswsRoute) {
  if (rswsRoute.stagingLocations.length) {
    return rswsRoute.stagingLocations
      .map((location) => location.displayLabel)
      .join(", ");
  }
  return "...";
}

/**
 * Returns parsed staging locations list for route.
 * @param rswsRoute
 * @return {*[]|{displayLabel: (null|string|*), label: (null|string|*), type: string}[]|*}
 */
export function transformStagingLocations(rswsRoute) {
  if (
    Array.isArray(rswsRoute.stagingLocations) &&
    rswsRoute.stagingLocations.length
  ) {
    return rswsRoute.stagingLocations.map((location) => {
      return {
        label: location.label,
        type: location.type,
        locationType: location.locationType,
        displayLabel: getDisplayLabel(location),
      };
    });
  } else if (rswsRoute.stagingLocation && rswsRoute.stagingLocation !== "...") {
    return [
      {
        label: rswsRoute.stagingLocation,
        displayLabel: rswsRoute.stagingLocation,
        type: STAGE_LOCATION_TYPE.NORMAL,
      },
    ];
  }
  return [];
}

function getDisplayLabel(location) {
  if (location.type === STAGE_LOCATION_TYPE.OVERFLOW) {
    return `${location.label}${OVERFLOW_LOCATION_SUFFIX}`;
  } else {
    return location.label;
  }
}



// WEBPACK FOOTER //
// ./src/components/outboundAmzl/util/DataTransformUtil.js